<template>
  <div>
    <SlottedContainerComponent
      :buttonText="
        $t('dashboard.documents.expand', { document_count: documents.length })
      "
      :expandable="true"
      :containerClass="`bg-white px-3 border-translucent`"
    >
      <template #title>
        <h4 class="my-2 font-serif">
          {{
            $t("dashboard.documents.section_title", {
              document_count: documents.length,
            })
          }}
        </h4>
      </template>
      <template #content>
        <DocumentCardComponent
          v-for="document in documents"
          :key="document.id"
          :document="document"
          :account_id="account_id"
          :is_admin="is_admin"
          :generator="getAssociatedGenerator(document)"
        />
      </template>
    </SlottedContainerComponent>
  </div>
</template>

<script setup lang="ts">
import SlottedContainerComponent from "@/components/common/SlottedContainerComponent.vue";
import DocumentCardComponent from "@/dashboard/invoice_management/DocumentCardComponent.vue";
import type { Document, Generator } from "@/types";

const props = defineProps<{
  documents: Document[];
  generators: Generator[];
  account_id: number;
  is_admin: boolean;
}>();

const getAssociatedGenerator = (document: Document) => {
  if (!document.generator_id) {
    return undefined;
  }
  return props.generators.find(
    (generator: Generator) => generator.id === document.generator_id
  );
};
</script>
